export default "__VITE_ASSET__d99b275d__"